"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _awsAmplify = require("aws-amplify");
var _reactRedux = require("react-redux");
var _actions = require("../actions");
var _usersDeprecated = require("../../../modules/users-deprecated");
var _helpers = require("../../../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};
class EditMe extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      me: (0, _helpers.mapSchemaToState)(_usersDeprecated.schema),
      messages: []
    });
    _defineProperty(this, "handleChange", body => {
      this.setState({
        me: {
          ...this.state.me,
          ...body
        }
      });
    });
    _defineProperty(this, "handleSubmit", event => {
      event.preventDefault();
      const {
        auth,
        update
      } = this.props;

      // const onSuccess = (store.edit && store.edit.onSuccess) ? store.edit.onSuccess : undefined;

      _awsAmplify.Auth.currentSession().then(data => {
        return update(this.state.me, {
          expand: auth.me.expand
        }, data.idToken.jwtToken).then(() => {
          this.clearMessages();
          this.addMessage({
            text: 'Your data was successfully modified!',
            type: 'success'
          });
        }).catch(error => {
          this.clearMessages();

          //console.dir(error);

          this.addMessage({
            text: error.Message,
            type: 'error'
          });
        });
      }).catch(err => console.log("Error: " + err));
    });
    _defineProperty(this, "clearMessages", () => this.setState({
      messages: []
    }));
    _defineProperty(this, "addMessage", message => this.setState({
      messages: [...this.state.messages, message]
    }));
  }
  componentDidMount() {
    if (this.props.me.fetched) {
      this.setState({
        me: {
          ...this.state.me,
          ...this.props.me.data
        }
      });
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.me.fetched !== nextProps.me.fetched) {
      this.setState({
        me: {
          ...this.state.me,
          ...this.props.me.data
        }
      });
    }
  }
  render() {
    const {
      children,
      auth,
      ...rest
    } = this.props;
    return _react.default.cloneElement(children, {
      state: this.state.me,
      messages: this.state.messages,
      onChange: this.handleChange,
      onSubmit: this.handleSubmit,
      fetching: auth.me.fetching,
      fetched: auth.me.fetched,
      ...rest
    });
  }
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  update: _actions.updateMe
})(EditMe);
module.exports = exports.default;